// extracted by mini-css-extract-plugin
export var readonly = "_ej-1";
export var star = "_ej-0";